export var rowdata = [{
        id: "1",
        ProductName: "Front bumper replacement",
        Code: "#01123223",
        UnitOfMeasurementName: "Eachs",
        Rate: "23453",
        ServiceType: "paid periodic",
        InvoicedQty: "10",
        Returnquantity: "11"
    }];
